import React, { useEffect, useState } from 'react';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.85);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-50 border-t border-sage/15 bg-white/95 pb-[env(safe-area-inset-bottom)] backdrop-blur-sm transition-[transform,opacity] duration-200 ease-out motion-reduce:transition-none lg:bottom-auto lg:top-0 lg:h-14 lg:border-b lg:border-t-0 lg:pb-0 ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-full opacity-0 lg:-translate-y-full'}`} data-id="element-276" data-mp="3pdsjn4nl8xrs">
      <div className="mx-auto flex h-full max-w-content items-center justify-between gap-3 px-4 py-3 sm:px-8 lg:py-0" data-id="element-277" data-mp="c5fqpw6b2x7i">
        <p className="min-w-0 font-sans text-[13px] font-semibold leading-tight text-ink sm:text-sm" data-id="element-278" data-mp="gztog58fxgfc">
          Screen &amp; Adapt™{' '}
          <span className="block font-medium text-ink-soft sm:inline" data-id="element-279" data-mp="27b0u38y7fxg">Yoga Edition</span>
        </p>
        <a href="#pricing" className="shrink-0 rounded-xl bg-sage px-4 py-3 font-sans text-[13px] font-semibold text-white transition-colors duration-150 ease-out hover:bg-sage-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage focus-visible:ring-offset-2 motion-reduce:transition-none sm:px-5 sm:text-sm lg:py-2" data-id="element-280" data-mp="gw77bvvcwkvy">
          Get instant access
        </a>
      </div>
    </div>;
}